module.exports = __webpack_public_path__ + "static/media/Joshua_Hill_Resume.d41d8cd9.pdf";